import { useState } from 'react';

const navItems = [
  { label: '关键速览', href: '#overview' },
  { label: '事件起因', href: '#cause' },
  { label: '完整时间线', href: '#timeline' },
  { label: '后续进展', href: '#followup' },
  { label: '常见疑问', href: '#faq' },
  { label: '讨论区', href: '#discussion' },
];

export default function SiteHeader() {
  const [open, setOpen] = useState(false);

  return (
    <header className="w-full border-b border-background-200 bg-background-50/90 backdrop-blur-md">
      <div className="flex h-16 w-full items-center gap-4 px-4 md:px-8">
        <a href="#top" className="flex shrink-0 items-center gap-2.5 cursor-pointer">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-anchor-line text-lg" />
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-bold tracking-wide text-foreground-950">
              海角黑料
            </span>
            <span className="mt-0.5 text-[10px] font-medium tracking-[0.22em] text-foreground-500">
              事件时间线
            </span>
          </span>
        </a>

        <nav className="ml-4 hidden items-center gap-1 md:flex">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600 cursor-pointer"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="ml-auto hidden items-center gap-3 lg:flex">
          <label className="flex items-center gap-2 rounded-md border border-background-200 bg-background-100 px-3 py-2">
            <i className="ri-search-line text-sm text-foreground-500" />
            <input
              type="text"
              placeholder="搜索关键节点"
              className="w-40 bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none"
            />
          </label>
          <a
            href="#timeline"
            className="flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
          >
            <i className="ri-play-list-2-line" />
            看时间线
          </a>
        </div>

        <button
          type="button"
          aria-label="打开目录"
          onClick={() => setOpen((prev) => !prev)}
          className="ml-auto flex h-10 w-10 items-center justify-center rounded-md border border-background-200 text-foreground-800 md:hidden cursor-pointer"
        >
          <i className={open ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} />
        </button>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
          <nav className="flex flex-col">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="whitespace-nowrap rounded-md px-3 py-3 text-sm text-foreground-700 transition-colors hover:bg-background-100 cursor-pointer"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#timeline"
              onClick={() => setOpen(false)}
              className="mt-2 flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-3 text-sm font-medium text-background-50 cursor-pointer"
            >
              <i className="ri-play-list-2-line" />
              看时间线
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}